import { render, staticRenderFns } from "./view_transaction.vue?vue&type=template&id=63b7a82f&scoped=true"
import script from "./view_transaction.vue?vue&type=script&lang=js"
export * from "./view_transaction.vue?vue&type=script&lang=js"
import style0 from "./view_transaction.vue?vue&type=style&index=0&id=63b7a82f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7a82f",
  null
  
)

export default component.exports